import { STRIDE } from './types';

export const pointCount = (points: Float32Array): number => points.length / STRIDE;

export interface BBox {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
}

export function bbox(points: Float32Array): BBox {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (let i = 0; i < points.length; i += STRIDE) {
    const x = points[i]!, y = points[i + 1]!;
    if (x < minX) minX = x;
    if (x > maxX) maxX = x;
    if (y < minY) minY = y;
    if (y > maxY) maxY = y;
  }
  return { minX, minY, maxX, maxY };
}

/**
 * Growable stride-6 sample buffer for capture. Values are stored as float32,
 * the same precision the platform delivers them at.
 */
export class SampleBuffer {
  private buf: Float32Array;
  private len = 0;

  constructor(initialPoints = 256) {
    this.buf = new Float32Array(initialPoints * STRIDE);
  }

  push(x: number, y: number, pressure: number, tiltX: number, tiltY: number, t: number): void {
    if (this.len + STRIDE > this.buf.length) {
      const next = new Float32Array(this.buf.length * 2);
      next.set(this.buf);
      this.buf = next;
    }
    const b = this.buf, i = this.len;
    b[i] = x; b[i + 1] = y; b[i + 2] = pressure; b[i + 3] = tiltX; b[i + 4] = tiltY; b[i + 5] = t;
    this.len += STRIDE;
  }

  get count(): number {
    return this.len / STRIDE;
  }

  /** Live view over the filled region; invalidated by the next push. */
  view(): Float32Array {
    return this.buf.subarray(0, this.len);
  }

  /** Exact-length copy, safe to store. */
  snapshot(): Float32Array {
    return this.buf.slice(0, this.len);
  }
}
